onReady(() => {
    const searchResultsBar = document.querySelector('.results-bar')

    if (!searchResultsBar) {
        return
    }

    const filterButtons = searchResultsBar.querySelectorAll('.filter-button');
    const clearFiltersButton = searchResultsBar.querySelector('.clear-filters');

    filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const filterValue = button.getAttribute('data-filter');
            const filterKey = button.getAttribute('data-filter-type');
            const params = new URLSearchParams(window.location.search);
            const currentFilterValues = params.get(filterKey)
                .split(' ')
            const updatedFilterValues = currentFilterValues.filter((value) => value !== filterValue)

            if (updatedFilterValues.length > 0) {
                params.set(filterKey, updatedFilterValues.join(' '))
            }
            else {
                params.delete(filterKey)
            }

            window.location.search = params.toString();
        });
    })

    if (clearFiltersButton) {
        clearFiltersButton.addEventListener('click', clearInsightsSearchFilters)
    }
});
